// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__31HJs","vertical":"_type_vertical__R_ahw"};